import React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { SupporterCommentCard } from './components/SupporterCommentCard';
import { ViewAllComments } from './components/ViewAllComments';
import { useSupporterComments } from './hooks/useSupporterComments';

export function SupporterVoicesComments(): React.JSX.Element | null {
	const {
		data: { supporterComments, petition },
	} = useSupporterComments();

	if (supporterComments.length === 0) {
		return null;
	}

	return (
		<div className="flex flex-col gap-6">
			<Text as="h3" fontWeight="normal" size="x-large" variant="body">
				<Translate value="corgi.petition_gamma.comments.title" />
			</Text>
			{supporterComments.map((comment) => {
				return <SupporterCommentCard key={comment.id} supporterComment={comment} petition={petition} />;
			})}
			<ViewAllComments petitionId={petition.id} slug={petition.slug} />
		</div>
	);
}
